import { Stack, Paper, Typography, Grid, Box } from "@mui/material";
import React from "react";
import company1 from "../../Images/company1.png";
import company2 from "../../Images/company2.png";
import "./Style.css";
import { aboutJacobCoffeeHouse } from "./businessInfo";
const AboutCompany = () => {
  return (
    <Stack>
      <Paper elevation={0} sx={{ padding: "2px 0" }}>
        <Typography
          component="h2"
          variant="h2"
          color="inherit"
          sx={{ color: "#626262", display: { xs: "none", md: "block" },fontWeight:600 ,fontSize: { xs: "1.5rem", lg: "2.5rem" },}}
        >
          About
        </Typography>

        <Typography
          component="h2"
          variant="h2"
          color="inherit"
          sx={{ color: "#005F8E", display: { xs: "none", md: "block" },fontWeight:600,fontSize: { xs: "1.5rem", lg: "2.5rem" }, }}
        >
          Jacob's Coffee House
        </Typography>
      {/* ------------------------------mobile view about our company------------------------------------   */}
        <Typography
          component="h2"
          variant="h4"
          color="inherit"
          sx={{ color: "#626262" , display: { sm: "block", md: "none" },fontSize: { xs: "1.5rem", lg: "2.5rem" },fontWeight:600}}
        >
          About
        </Typography>

        <Typography
          component="h2"
          variant="h4"
          color="inherit"
          sx={{ color: "#005F8E" , display: { sm: "block", md: "none" },fontSize: { xs: "1.5rem", lg: "2.5rem" },fontWeight:600}}
        >
          Jacob's Coffee House
        </Typography>
        <Grid
          container
          spacing={3}
          sx={{ marginBottom: { xs: 0, md: 15 }, marginTop: 0 }}
        >
          <Grid item xs={12} md={6}>
            <Box sx={{ lineHeight: 2, textAlign: "justify", fontSize: { md: "16px", lg: "19px" },}}>
              <Typography
                component="h3"
                variant="h5"
                sx={{ color: "#005F8E", fontWeight: 600, mb: 2 }}
              >
                {aboutJacobCoffeeHouse.title}
              </Typography>
              {aboutJacobCoffeeHouse.paragraphs.map((paragraph) => (
                <Typography
                  key={paragraph}
                  component="p"
                  sx={{ lineHeight: 2, mb: 2, textAlign: "justify" }}
                >
                  {paragraph}
                </Typography>
              ))}
              <Typography
                component="h3"
                variant="h5"
                sx={{ color: "#005F8E", fontWeight: 600, mb: 2, mt: 3 }}
              >
                {aboutJacobCoffeeHouse.workWithUsTitle}
              </Typography>
              <Typography component="p" sx={{ lineHeight: 2, textAlign: "justify" }}>
                {aboutJacobCoffeeHouse.workWithUs}
              </Typography>
            </Box>
          </Grid>
          <Grid item md={6}>
            <Box
              sx={{
                position: "relative",
                display: { sm: "none", md: "block" },
              }}
            >
              <img
                src={company1}
                alt="Image 1"
                height="400px"
                className="about-img1"
              />
              <img
                src={company2}
                alt="Image 2"
                height="350px"
                className="about-img2"
              />
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Stack>
  );
};

export default AboutCompany;
